import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";
import { OrganizationData } from "./sign-in-organization";

export const mapOrganizationsToComboBoxItemModel = (
  organizations?: OrganizationData[]
): ComboBoxItemModel[] | undefined => {
  if (!organizations) {
    return [];
  }
  return organizations.map(organization => ({
    value: organization.id,
    caption: organization.name
  }));
};
